import React from 'react';
import PropTypes from 'prop-types';
import EditTutorialPopUp from 'modules/categories/components/TutorialPopup';
import {inject} from 'mobx-react';
import {observe} from 'mobx';
import Player from '@vimeo/player';
import {EDIT_TUTORIAL_TYPE} from 'constants/adminPupups';
import pdf from 'images/pdf-icon.svg';

const style = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
};

@inject('preloaderStore')
@inject('vimeoVideo')
@inject('editableCategoryStore')
@inject('userStore')
// @observer
export default class TutorialVideo extends React.Component {
  static propTypes = {
    tutorial_title: PropTypes.string,
    tutorial_src: PropTypes.string,
    tutorial_desc: PropTypes.string,
    isAdmin: PropTypes.bool
  };
  static defaultProps = {
    tutorial_title: '',
    tutorial_src: '',
    tutorial_desc: '',
    isAdmin: false
  };

  componentWillMount(){
    this.listener = observe(this.props.vimeoVideo, 'scrollTo', () => {
      if(this.props.vimeoVideo.scrollTo instanceof Number)
        this.handleScroll(this.props.vimeoVideo.scrollTo);
    })
  }

  componentWillUnmount(){
    this.listener();
  }

  handleScroll = time => {
    this.player.getCurrentTime().then(() => {
      this.player.setCurrentTime(time == 0 ? 0.01 : time);
      this.player.play()
    }).catch(() => {})
  };

  handleOpen = () => {
    this.props.editableCategoryStore.activate(EDIT_TUTORIAL_TYPE, this.props.id);
  };

  handleTutorial = () => {
    const {isAdmin} = this.props;
    if (isAdmin) {
      return <EditTutorialPopUp key="2" dontUpdate={true} initTutorial={this.props.initTutorial}/>
    }
  };

  endTimePlayer = () => {
    this.player.on('timeupdate', data => {
      if(this.props.vimeoVideo.endTime && (data.seconds > this.props.vimeoVideo.endTime) ){
        this.player.pause().then(()=> {
          this.props.vimeoVideo.scrollVideoTo(null, null);
        })
      }
    })
  };

  handleIframeLoad = () => {
    this.props.preloaderStore.disable();
    let iframe = document.querySelector('iframe');
    this.player = new Player(iframe);
    window.player = this.player
    this.endTimePlayer();
  };

  openQuizModal = () => {
    this.props.openQuizModal();
  }

  renderPdfButton = cpd_status => {
    const {id} = this.props;
    const token = localStorage.getItem('token');

    return (
      cpd_status ?
        <a
          className="btn blue rounded submit-btn"
          style={{
            marginTop: '40px',
            backgroundColor: 'white',
            border: '1px solid #28b5f4',
            color: '#28b5f4'
          }}
          href={`https://prescriptionrevision.com/api/v1/pdfs/${id}?token=${token}`}
          target='_blank'
        >
          <img src={pdf} alt="pdf" style={{marginRight: '10px'}} />
          View CPD Cert
        </a> :
        null
    );
  }

  render() {
    const {tutorial_title, tutorial_src, tutorial_desc, completed, cpd_status} = this.props;
    const EditTutorial = this.handleTutorial();

    return (
      <div className="tutorial-main-wrap">
        {this.props.userStore.isAdmin() && [<button className="btn blue floating-btn edit-tutorial-btn ic ic-edit modal"
                  onClick={this.handleOpen}
                  key="1"
                  type="button"/>,

          EditTutorial]
        }
        <div className="tutorial-header">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="tutorial-video-wrap col-md-8">
                <div className="tutorial-video-inner">
                  {tutorial_src &&
                    <iframe src={tutorial_src}
                            frameBorder="0"
                            allowFullScreen
                            style={style}
                            onLoad={this.handleIframeLoad}/>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tutorial-bottom">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="tutorial-video-info col-md-8">
                <h3 className="tutorial-title">{tutorial_title}</h3>
                <div className="desc">
                  {tutorial_desc}
                </div>
                { completed ?
                  this.renderPdfButton(cpd_status) :
                  <button
                    className="btn blue rounded submit-btn"
                    onClick={ this.openQuizModal }
                    style={{ marginTop: '40px' }}
                  >
                    Take The Cpd Quiz
                  </button>
                }
                { completed ?
                  <div className="desc" style={{fontSize: '12px'}}>
                    You have passed the CPD quiz for this module
                  </div> :
                  <div className="desc" style={{fontSize: '12px'}}>
                    You need to answer 8 out of 10 questions to pass the test
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/tutorial/components/TutorialVideo.js